export default __webpack_public_path__ + "static/media/bg_map_3.288af0c2.png";